export const filterObject = (originalObject: object, ignoreList: string[]): object =>
    Object.keys(originalObject)
        .filter((key) => !ignoreList.includes(key))
        .reduce(
            (obj, key) => ({
                ...obj,
                [key]: originalObject[key]
            }),
            {}
        );
